import AuthUser from "./UserAuth";
import Bags from "./bag";
import Cities from "./Cities";
import ClientAddress from "./clientAddress";
import ClientPickupList from "./ClientPickupRequest";
import ClientProducts from "./ClientProducts";
import ClientServiceTypes from "./ClientServiceTypes";
import ClientShiping from "./ClientShiping";
import Clients from "./Clients";
import CommunicationHistory from "./CommunicationHistory";
import Countries from "./Countries";
import CustomsShipment from "./CustomsShipment";
import DailyDeliveryReport from "./DailyDeliveryReport";
import Departments from "./Departments";
import Districts from "./Districts";
import Employees from "./Employees";
import FirstMileShipment from "./FirstMileShipment";
import Hubs from "./Hubs";
import InBoundShipment from "./InBoundShipment";
import Indicator from "./Indicator";
import LastMileShipment from "./LastMileShipment";
import Manifest from "./manifest";
import Cargo from "./Cargo";
import CargoManifest from "./CargoManifest";
import OutBoundShipment from "./OutBoundShipment";
import TPLPartner from "./TPLPartner";
import RTSRequest from "./RTS-Request";
import DTSRequest from "./DTSRequest";
import AmazonPrices from "./Amazon";
import Regions from "./Regions";
import Scan from "./Scan";
import ServiceTypes from "./ServiceTypes";
import ShipmentCount from "./ShipmentCount";
import ShipmentList from "./Shipments";
import ShipmentStatusWise from "./client/ClientDashboard";
import ShipmentSummary from "./ShipmentSummary";
import ThemeOptions from "./ThemeOptions";
import TripSheet from "./TripSheet";
import TplManifest from "./TplManifest";
import TPLCity from "./TPLCities";
import TPLInvoice from "./TPLInvoice";
import PrintTPLLogs from "./PrintTPLLogs";
import Payment from "./payment";

import Pieces from "./order/Pieces";
import InboundPieces from "./order/InboundPieces";
import ProductSKU from "./order/ProductSKU";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ThemeOptions,
  AmazonPrices,
  AuthUser,
  Countries,
  Regions,
  Hubs,
  Cities,
  Districts,
  Indicator,
  ClientShiping,
  ServiceTypes,
  TPLPartner,
  ClientPickupList,
  CustomsShipment,
  FirstMileShipment,
  InBoundShipment,
  OutBoundShipment,
  LastMileShipment,
  Departments,
  Employees,
  Clients,
  ClientProducts,
  ClientServiceTypes,
  ClientAddress,
  Scan,
  CommunicationHistory,
  ShipmentList,
  Bags,
  TripSheet,
  ShipmentSummary,
  ShipmentStatusWise,
  ShipmentCount,
  DailyDeliveryReport,
  RTSRequest,
  Manifest,
  Cargo,
  CargoManifest,
  TplManifest,
  DTSRequest,
  TPLCity,
  TPLInvoice,
  PrintTPLLogs,
  Payment,

  Pieces,
  InboundPieces,
  ProductSKU
};
